import { Card, type CardProps } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const StyledResponsiveCard = styled(Card)`
  .ant-card-body {
    ${down('sm')} {
      padding: 12px;
    }
  }
  &.no-padding {
    > .ant-card-body {
      padding: 0;
      ${down('sm')} {
        padding: 0;
      }
    }
    // se ci sono i tabs, il padding superiore deve essere almeno 1px 
    // per mostrare correttamente il filo dei tabs
    &.ant-card-contain-tabs {
      > .ant-card-body {
        padding: 1px;
        ${down('sm')} {
          padding: 1px;
        }
      }
    }
  }

  &.hide-card-header {
    .ant-card-head {
      display: none;
    }
    // se la card contiene tabs, la header non viene nascosta 
    // ma vengono nascosti titolo e pulsante extra, per mostrare correttamente i Tabs
    &.ant-card-contain-tabs {
      .ant-card-head {
        display: flex;

        .ant-card-head-title {
          display: ${props =>
            props.theme.searchButtonOnTableFlag ? 'none' : 'inline-block'};
        }
        .ant-card-extra:empty {
          display: ${props =>
            props.theme.searchButtonOnTableFlag ? 'none' : 'block'};
        }
      }
    }
  }
  // ridotto padding inferiore del pulsante del Tab (Card con Tabs)
  &.ant-card-contain-tabs {
    .ant-card-head .ant-tabs > .ant-tabs-nav .ant-tabs-tab {
      padding-bottom: 12px;
    }
  }
`;

export interface ResponsiveCardProps extends CardProps {
  /** Rimuove il padding del body della Card */
  noPadding?: boolean;
  /** Rimuove l'intestazione della Card
   *
   * Utilizzato quando il contenuto della header della Card
   * viene spostato nell'intestazione, se presente il flag searchButtonOnTableFlag
   *
   * Se sono presenti i Tabs nella Card la header viene mostrata
   * e vengono rimossi solo titolo e pulsante extra, per mostrare correttamente i Tabs
   */
  hideCardHeader?: boolean; // Flag per mostrare il pulsante di ricerca nella Card
}

/**
 * Card Responsive
 * riduce il padding del body dalla Card (da 24px a 12px)
 * se impostato noPadding rimuove Sempre il padding del body
 *
 * @param noPadding Rimuove Sempre il padding del body della Card
 */
export function ResponsiveCard(props: ResponsiveCardProps) {
  const { noPadding, className, hideCardHeader, ...cardProps } = props;
  return (
    <StyledResponsiveCard
      bordered={false}
      {...cardProps}
      className={clx(className, 'responsive-card', {
        'no-padding': noPadding,
        'hide-card-header': hideCardHeader,

        // utilizzato in TopCardButtonContainer e ButtonRowCardFooter
        // per correggere il padding del bottone superiore integrato alla card
        'has-padding': !noPadding,
      })}
    />
  );
}
